import { useEffect, useSyncExternalStore } from "react";
import { useLocation } from "react-router-dom";

// Breadcrumb registry: one entry per browser-history index (react-router stores idx in history.state).
const KEY = "rh.trail";
const listeners = new Set();
let entries = JSON.parse(sessionStorage.getItem(KEY) || "[]");

const emit = () => { sessionStorage.setItem(KEY, JSON.stringify(entries)); listeners.forEach((l) => l()); };
export const historyIdx = () => window.history.state?.idx ?? 0;
const subscribe = (l) => { listeners.add(l); return () => listeners.delete(l); };
const getEntries = () => entries;

export const ROOTS = {
  "/albums": (search) => (new URLSearchParams(search).get("sort") || "recent") === "recent" ? "Recently Added" : "Albums",
  "/artists": "Artists", "/songs": "Songs", "/favorites": "Favorites", "/playlists": "Playlists", "/radio": "Radio",
  "/stats": "Stats", "/offline": "Offline music", "/builder": "Playlist Builder", "/wishlist": "Wishlist",
  "/duplicates": "Duplicates", "/upload": "Upload music", "/settings": "Settings", "/missing-art": "Missing art",
};

// Called on every location change: drops stale forward entries and records the current page.
export function syncLocation(pathname, search) {
  const idx = historyIdx();
  const path = pathname + search;
  if (entries[idx]?.path === path) return;
  const root = ROOTS[pathname];
  const label = typeof root === "function" ? root(search) : root || null;
  entries = entries.slice(0, idx);
  entries[idx] = { path, label, root: !!root };
  emit();
}

// Detail pages register their title once loaded; `parent` is shown when the user deep-linked without a root page in history.
export function useCrumb(label, parent) {
  const { pathname, search } = useLocation();
  useEffect(() => {
    if (!label) return;
    syncLocation(pathname, search);
    const idx = historyIdx();
    entries = [...entries];
    entries[idx] = { ...entries[idx], label, parent };
    emit();
  }, [label, parent, pathname, search]);
}

export const useTrailEntries = () => useSyncExternalStore(subscribe, getEntries);
